import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useOutletContext, useParams } from 'react-router-dom';

import NoteList from '@/components/NoteList';
import TaskList from '@/components/TaskList';
import { Encounter, ENCOUNTER_TYPES } from '@/types/encounter';
import Container from '@/ui/components/Container';

import BillingItem from '../EncounterDetailsHome/components/BillingItem';

const EncounterDetailsBilling = () => {
  const { encounter, refetchEncounter } = useOutletContext<{
    encounter: Encounter;
    path: ENCOUNTER_TYPES;
    refetchEncounter: () => void;
  }>();
  const { encounterId, encounterType } = useParams<{
    encounterId: string;
    encounterType: string;
  }>();
  const { state } = useLocation();

  if (!encounter) return <p>Missing Encounter</p>;

  if (!encounterType) return <p>Unsupported Encounter Type</p>;

  return (
    <Container type="page">
      {/* A real URL rather than history back -- this view is deep linked into from
          the chrome extension, where there is no previous entry to go back to. */}
      <Link
        to={`/encounters/${encounterType}/by_id/${encounterId}`}
        state={state}
        className="inline-flex items-center mb-2 text-blue-600 hover:text-blue-800">
        <FontAwesomeIcon icon={faChevronLeft} className="mr-1" />
        Back to encounter
      </Link>
      <BillingItem
        billingItem={encounter.billing_item}
        charts={encounter.charts}
        encounterType={encounterType as ENCOUNTER_TYPES}
        refetchEncounter={refetchEncounter}
      />
      {encounter.person && encounter.billing_item && encounter.billing_item.id && (
        <>
          <NoteList
            object_id={encounter.billing_item.id}
            object_name={`this encounter`}
            contentTypeName={encounterType}
          />
          <TaskList
            personId={encounter.person.id}
            object_id={encounter.billing_item.id}
            object_name={`this encounter`}
            contentTypeName="billing.billingitem"
          />
        </>
      )}
    </Container>
  );
};

export default EncounterDetailsBilling;
